export default {_name:'image',module:'Field',view:'Element/Image',options:{key:'image',ms:12,xs:12}}